module.exports = __webpack_public_path__ + "img/组织映射.b0420794.svg";